import type { UserDocumentDto } from '../api/UserDocumentApi';

/**
 * A client's documents that could be the citation for a new case: not yet filed on any case, and a
 * photo, scan or PDF. Newest first, since the citation is usually the latest thing staff attached.
 *
 * Lloyd, Oct 2026: "since I already uploaded her citation, that should have been automatic." Add Case
 * offers these instead of asking for the same file again.
 */
const CITATION_LIKE = /\.(pdf|png|jpe?g|gif|webp)$/i;

export function citationCandidatesOnFile(documents: UserDocumentDto[]): UserDocumentDto[] {
  return documents
    .filter((document) => !document.Ticket_guid && CITATION_LIKE.test(document.UserDocument_Name))
    .sort((a, b) => (b.UserDocument_CreatedAt ?? '').localeCompare(a.UserDocument_CreatedAt ?? ''));
}
